import Cookies from 'js-cookie';
// import focusLock from 'dom-focus-lock';
import * as focusTrap from 'focus-trap';

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initialize);
} else {
	initialize();
}



/*
* Script to handle the cookie-banner and consents.
*/

var unloads = [];
var consentModule = document.getElementById('consent-overlay');
var consentModuleSimple = document.getElementById('consent-basic-container');
var consentModuleAdvanced = document.getElementById('consent-advanced-container');

var trapSimple = focusTrap.createFocusTrap(consentModuleSimple, {initialFocus: false});
var trapAdvanced = focusTrap.createFocusTrap(consentModuleAdvanced, {initialFocus: false});

function initialize () {
	/*
	* Document has loaded. Handle consent-modal per earlier consents (if any)
	*/
	var hasAnswered = Cookies.get('_cookie_banner_answered');

	if (hasAnswered) {
		// allow cookies from only the consented checkboxes.
		var analytical = Cookies.get('_cookie_banner_analytics');
		var marketing = Cookies.get('_cookie_banner_marketing');
		
		console.log('initial consent:', {analytical, marketing});
		// IMPORTANT: Initial consent is already set in <head> tag.
	} else {
		// show cookie banner!
		openModal();
		
		console.log('initial consent:', {analytical: false, marketing: false});
		// IMPORTANT: Initial consent is already set in <head> tag.
	}

	var closeConsentOverlayBtns = document.querySelectorAll('.close-consent-overlay');
	closeConsentOverlayBtns.forEach((item, i) => {
		item.addEventListener('click', closeModal);
		unloads.push({event: 'click', func: closeModal, elem: item});
	});

	var consentAllowAllBtn = document.querySelector('.consent-allow-all');
	consentAllowAllBtn.addEventListener('click', allowAll);
	unloads.push({event: 'click', func: allowAll, elem: consentAllowAllBtn});

	var consentRejectAllBtn = document.querySelector('.consent-reject-all');
	consentRejectAllBtn.addEventListener('click', rejectAll);
	unloads.push({event: 'click', func: rejectAll, elem: consentRejectAllBtn});

	var consentAllowSelectionBtn = document.querySelector('.consent-allow-selection');
	consentAllowSelectionBtn.addEventListener('click', allowSelection);
	unloads.push({event: 'click', func: allowSelection, elem: consentAllowSelectionBtn});

	var selectConsentTypesBtn = document.getElementById('consent-module-select-cookies');
	selectConsentTypesBtn.addEventListener('click', openConsentTypesSelection);
	unloads.push({event: 'click', func: openConsentTypesSelection, elem: selectConsentTypesBtn});

	/**
	 * Reset consent button
	 */
	var updateConsentBtn = document.getElementById('update-cookie-consent-preferences');
	if (updateConsentBtn) {
		updateConsentBtn.addEventListener('click', resetConsent);
		unloads.push({event: 'click', func: resetConsent, elem: updateConsentBtn});
	}

	unloads.push({event: 'beforeunload', func: unload, elem: window});
	window.addEventListener('beforeunload', unload);
}

function unload () {
	/*
	* Multiple listeners has been created. Remove them when site closes.
	*/
	unloads.forEach((item, i) => {
		console.log('unloading:', item.event);
		item.elem.removeEventListener(item.event, item.func);
	});
}

function openModal () {
	/*
	* Opens the consent modal.
	*/
	consentModule.setAttribute('tabindex', '0');
	consentModule.setAttribute('aria-hidden', 'false');
	consentModule.classList.add('active');
	consentModuleSimple.classList.add('active');

	trapSimple.activate();
	trapAdvanced.deactivate();
	// focusLock.on(consentModuleSimple);
}

function closeModal () {
	/*
	* Closes the consent modal.
	*/
	consentModule.classList.remove('active');
	consentModuleSimple.classList.remove('active');
	consentModuleAdvanced.classList.remove('active');
	consentModule.setAttribute('tabindex', '-1');
	consentModule.setAttribute('aria-hidden', 'true');

	// focusLock.off(consentModuleSimple);
	// focusLock.off(consentModuleAdvanced);
	trapSimple.deactivate();
	trapAdvanced.deactivate();
}

function openConsentTypesSelection () {
	/*
	* Opens the settings popup, and closes the simple banner.
	*/
	consentModuleSimple.classList.remove('active');
	consentModuleAdvanced.classList.add('active');

	// focusLock.off(consentModuleSimple);
	// focusLock.on(consentModuleAdvanced);
	trapSimple.deactivate();
	trapAdvanced.activate();
}

function allowAll () {
	/*
	* When a user clicks "Allow all", we should set cookies that reflects the choice, and
	* init each scripts that are waiting for consent.
	*/
	console.log('consentAllowAll');
	Cookies.set('_cookie_banner_answered', 'true', { expires: 365 });
	Cookies.set('_cookie_banner_analytics', 'true', { expires: 365 });
	Cookies.set('_cookie_banner_marketing', 'true', { expires: 365 });
	closeModal();
	init3rdPartyScripts(true, true);
}

function rejectAll () {
	/*
	* When a user clicks "Reject all", we should set cookies that reflects the choice, and
	* don't init any scripts.
	*/
	console.log('consentRejectAll');
	Cookies.set('_cookie_banner_answered', 'true', { expires: 365 });

	closeModal();
}

function allowSelection () {
	/*
	* When a user clicks "Allow" in settings-popup, we should set cookies that reflects the choice, and
	* init each scripts that are waiting for consent.
	*/
	console.log('consentAllowSelection');

	Cookies.set('_cookie_banner_answered', 'true', { expires: 365 });

	var allowAnalytics = false;
	var allowMarketing = false;

	var checkBoxes = consentModuleAdvanced.querySelectorAll('[type="checkbox"]'); // get the checkboxes
	checkBoxes.forEach((item, i) => {
		if (item.checked) {
			// checkbox is checked. Only set cookie for checked boxes.
			switch (item.name) {
				case 'analytics':
					console.log('Allow analytics cookies');
					Cookies.set('_cookie_banner_analytics', 'true', { expires: 365 });
					allowAnalytics = true;
					break;
				case 'marketing':
					console.log('Allow marketing cookies');
					Cookies.set('_cookie_banner_marketing', 'true', { expires: 365 });
					allowMarketing = true;
					break;
				case 'necessary':
					console.log('Necessary / Not uncheckable');
					break;
				default:
					console.warn('Checkbox not known');
			}
		}
	});

	closeModal();
	init3rdPartyScripts(allowAnalytics, allowMarketing);
}

function resetConsent () {
	/*
	* Resets all cookies for the settings, aswell as denies cookies in third-party scripts until
	* new consent. It also opens the consent box so the user can choose again.
	*/
	console.log('resetConsent');
	Cookies.remove('_cookie_banner_answered');
	Cookies.remove('_cookie_banner_analytics');
	Cookies.remove('_cookie_banner_marketing');
	openModal();
	denyCookies();
}

function denyCookies () {
	/*
	* Disables all 3rd-party scripts from setting/using cookies. Using the 3rd-party consent api's.
	*/
	console.log('Disable all cookies');
	if (window.gtag) {
		console.log({consent: 'denied'})
		window.gtag('consent', 'update', {
			'ad_storage': 'denied',
			'ad_user_data': 'denied',
			'ad_personalization': 'denied',
			'analytics_storage': 'denied'
		});
		window.gtag('event', 'consent-update'); // trigger a gtm-trigger which will trigger tags that are waiting for consent.
	}
}

function init3rdPartyScripts (analytics = false, marketing = false) {
	/*
	* Enables (only the allowed) 3rd-party scripts to set/use their cookies. Using the 3rd-party consent api's.
	*/
	console.log('Init 3rd-party cookies:', {analytics, marketing});
	
	if (window.gtag) {
		console.log({consent: {
			'ad_storage': marketing ? 'granted' : 'denied',
			'ad_user_data': marketing ? 'granted' : 'denied',
			'ad_personalization': marketing ? 'granted' : 'denied',
			'analytics_storage': analytics ? 'granted' : 'denied'
		}})
		window.gtag('consent', 'update', {
			'ad_storage': marketing ? 'granted' : 'denied',
			'ad_user_data': marketing ? 'granted' : 'denied',
			'ad_personalization': marketing ? 'granted' : 'denied',
			'analytics_storage': analytics ? 'granted' : 'denied'
		});
		window.gtag('event', 'consent-update'); // trigger a gtm-trigger which will trigger tags that are waiting for consent.
	}
}
